module.exports = __webpack_public_path__ + "img/venestor-6f65a9fe-394c-43ec-d667-08d957755ecc.png";